import * as React from 'react'

import './styles.scss'
import { configurations } from '../../api'
import { BrandsAndDelegations, Button, ButtonTag, SelectWithLabel } from 'components/Form'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import ModalChannelList from './ModalChannelList'
import ColorPickerInput from 'components/ColorPickerInput'
import { channelName, chatmailProviders } from 'constants/channels'
import { InputControls } from 'components/common'
import { lang } from 'utils/helpers'
const _ = require('lodash')

const WebWidgetCreator = (props) => {
  const { channels, dataToEdit, setDataToEdit, dataCloneQrToWebWidget } = props
  const [channelList, setChannelList] = React.useState(channels || [])
  const [channel, setChannel] = React.useState([])
  const [brands, setBrands] = React.useState([])
  const [delegations, setDelegations] = React.useState([])
  const [order, setOrder] = React.useState({ value: 'asc', label: lang('order_by_az') })
  const [channelColor, setChannelColor] = React.useState('#E87721')
  const [automaticMessage, setAutomaticMessage] = React.useState('')
  const [automaticMessageValue, setAutomaticMessageValue] = React.useState('')
  const [automaticMessageToggles, setAutomaticMessageToggles] = React.useState({ autoMsgInDesktop: false, autoMsgInMobile: false })
  const [selectedChannels, setSelectedChannels] = React.useState([])
  const [orientationOptions, setOrientationOptions] = React.useState([{ label: 'Horizontal', value: 'horizontal' }, { label: 'Vertical', value: 'vertical' }])
  const [orientationOptionsM, setOrientationOptionsM] = React.useState([{ label: 'Horizontal', value: 'horizontal' }, { label: 'Vertical', value: 'vertical' }])
  const [orientation, setOrientation] = React.useState(orientationOptions[0])
  const [orientationM, setOrientationM] = React.useState(orientationOptionsM[0])
  const [selectedAocs, setSelectedAocs] = React.useState(9)
  const [selectedAocsM, setSelectedAocsM] = React.useState(9)
  const [name, setName] = React.useState('')
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const [errorMessageContent, setErrorMessageContent] = React.useState('')
  const [errorMessageName, setErrorMessageName] = React.useState('')
  const [errorMessageOrientation, setErrorMessageOrientation] = React.useState('')
  const [errorMessageOrientationM, setErrorMessageOrientationM] = React.useState('')
  const channelsApi = configurations.channels
  const orderField = { value: 'channel' }
  const channelOptions = _.filter(_.map(channelName, (value, key) => ({
    label: lang(value.name),
    value: key,
    notShow: value.notShow,
    order: value.order
  })), (it) => !it.notShow && it.value !== 'wall').sort((a, b) => a.order - b.order)
  const orientationOptionsDefault = [
    { label: 'Horizontal', value: 'horizontal' },
    { label: 'Horizontal Izquierda', value: 'horizontalLeft' },
    { label: 'Horizontal Derecha', value: 'horizontalRight' },
    { label: 'Vertical', value: 'vertical' },
    { label: 'Vertical Arriba', value: 'verticalUp' },
    { label: 'Vertical Abajo', value: 'verticalDown' }
  ]
  const AUTOMATIC_MESSAGE_LIMIT = 200

  React.useEffect(() => {
    getChannels(brands, delegations, channel)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brands, delegations, channel])

  React.useEffect(() => {
    let _channels = []
    if (dataCloneQrToWebWidget) {
      fillDataClone(dataCloneQrToWebWidget)
      dataCloneQrToWebWidget.channels.forEach(it => {
        const channel = channels.find(c => c._id === it.identifier)
        if (channel) {
          channel.isChecked = true
          channel.isMobile = true
          channel.isDesktop = true
          _channels.push({ ...channel })
        }
      })
    }
    handleSelectedChannels(_channels)
    setChannelList(channels)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCloneQrToWebWidget])

  React.useEffect(() => {
    if (!dataCloneQrToWebWidget) {
      channels.forEach(it => { it['isChecked'] = null })
    }
    setChannelList(channels)
  }, [channels])

  React.useEffect(() => {
    if ([1, 2, 5, 9].includes(selectedAocs))
      setOrientationOptions(orientationOptionsDefault.filter(it => ['horizontal', 'vertical'].includes(it.value)))
    if ([3, 4,].includes(selectedAocs))
      setOrientationOptions(orientationOptionsDefault.filter(it => ['horizontal', 'verticalUp', 'verticalDown'].includes(it.value)))
    if ([6, 7, 8].includes(selectedAocs))
      setOrientationOptions(orientationOptionsDefault.filter(it => ['horizontalLeft', 'horizontalRight', 'vertical'].includes(it.value)))
    handleOrientation([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAocs])

  React.useEffect(() => {
    if ([1, 2, 5, 9].includes(selectedAocsM))
      setOrientationOptionsM(orientationOptionsDefault.filter(it => ['horizontal', 'vertical'].includes(it.value)))
    if ([3, 4,].includes(selectedAocsM))
      setOrientationOptionsM(orientationOptionsDefault.filter(it => ['horizontal', 'verticalUp', 'verticalDown'].includes(it.value)))
    handleOrientationM([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAocsM])

  React.useEffect(() => {
    if (dataToEdit) {
      handleName(dataToEdit?.name)
      setChannelColor(dataToEdit?.primaryColor)
      setSelectedAocs(dataToEdit?.alignment)
      setSelectedAocsM(dataToEdit?.alignmentMobile)
      setAutomaticMessageValue(dataToEdit?.automaticMessage)
      setAutomaticMessageToggles({
        autoMsgInDesktop: !!dataToEdit?.autoMsgInDesktop,
        autoMsgInMobile: !!dataToEdit?.autoMsgInMobile
      })

      let _channels = []
      let _channelList = _.cloneDeep(channelList)
      dataToEdit.channels.forEach(it => {
        _channelList.forEach(it2 => {
          if (it2._id === it.identifier) {
            it2['isChecked'] = true
            it2['isMobile'] = it?.isMobile
            it2['isDesktop'] = it?.isDesktop
            _channels.push({ ...it2 })
          }
        })
      })
      handleSelectedChannels(_channels)
      setChannelList(_channelList)

      setTimeout(() => {
        handleOrientation(orientationOptionsDefault.find(it => it.value === dataToEdit?.position))
        handleOrientationM(orientationOptionsDefault.find(it => it.value === dataToEdit?.positionMobile))
      }, 10)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToEdit])

  const handleOrientation = (value) => {
    setOrientation(value)
    setErrorMessageOrientation('')
  }

  const handleOrientationM = (value) => {
    setOrientationM(value)
    setErrorMessageOrientationM('')
  }

  const handleName = (value) => {
    setName(value)
    setErrorMessageName('')
  }

  const handleSelectedChannels = (value) => {
    setSelectedChannels(value)
    setErrorMessage('')
  }

  const handleAutomaticMessage = (value) => {
    setAutomaticMessage(value)
    setErrorMessageContent('')
  }

  const fillDataClone = (cloneData) => {
    handleName(cloneData.name)
    setChannelColor(cloneData.color)
    setAutomaticMessageValue(cloneData.phrase)
  }

  const onChange = (value, type) => {
    if (type === 'brand') {
      setBrands(value[0]?.value ? value : [])
      setDelegations([])
    }
    else if (type === 'delegation') {
      setDelegations(value[0]?.value ? value : [])
    }
    else if (type === 'order') {
      setOrder(value)
      setChannelsAndOrder(channelList, value)
    }
    else if (type === 'channel') {
      setChannel(value[0]?.value ? value : [])
    }
  }

  const getChannels = (_brands, _delegations, _channel) => {
    let _channelList = _.clone(channels)
    if (_brands.length > 0) {
      _channelList = _channelList.filter(it => it.brandDefault === _brands[0].value)
    }
    if (_delegations.length > 0) {
      _channelList = _channelList.filter(it => it.delegationDefault === _delegations[0].value)
    }
    if (_channel.length > 0) {
      if (_channel[0].value === 'chatmail') _channelList = _channelList.filter(it => chatmailProviders.includes(it.key))
      else if (_channel[0]?.value === 'whatsapp_whatsapp') _channelList = _channelList.filter(it => it.hub === 'whatsapp')
      else if (_channel[0]?.value === 'whatsapp') _channelList = _channelList.filter(it => it.key === _channel[0]?.value && it.hub === 'twilio')
      else _channelList = _channelList.filter(it => it.key === _channel[0].value || it.value.connectionType === _channel[0].value)
    }
    setChannelsAndOrder(_channelList)
  }

  const setChannelsAndOrder = (_channels = channelList, _order = order, _orderField = orderField) => setChannelList(_channels)

  const createWidget = () => {
    let error = false
    if (selectedChannels.length === 0) {
      setErrorMessage(lang('channels_message_select_one_channel'))
      error = true
    }

    if (selectedChannels.find(channel => (!channel.isMobile && !channel.isDesktop))) {
      setErrorMessage(lang('channels_message_select_one_channel_option'))
      error = true
    }

    if (!name) {
      setErrorMessageName(lang('channels_message_no_name'))
      error = true
    }
    if (automaticMessage.length > AUTOMATIC_MESSAGE_LIMIT) {
      setErrorMessageContent(lang('dashboard_automatic-message-limit-200'))
      error = true
    }
    if (!orientation?.value) {
      setErrorMessageOrientation(lang('channels_message_select_orientation'))
      error = true
    }
    if (!orientationM?.value) {
      setErrorMessageOrientationM(lang('channels_message_select_orientation'))
      error = true
    }

    if (error) return

    setIsSubmitting(true)
    const config = {
      primaryColor: channelColor,
      position: orientation.value,
      alignment: selectedAocs,
      positionMobile: orientationM.value,
      alignmentMobile: selectedAocsM,
      automaticMessage,
      name: name,
      channels: selectedChannels.map((channel) => {
        return {
          name: channel.key,
          identifier: channel._id,
          isMobile: channel.isMobile,
          isDesktop: channel.isDesktop
        }
      }),
      ...automaticMessageToggles
    }
    if (!dataToEdit) {
      channelsApi.createWebWidget(config).then((response) => {
        setIsSubmitting(false)
        props.createWebWidget(config, selectedChannels, response.data.token, true)
        setChannel([])
        setBrands([])
        setDelegations([])
        setChannelList(channels)
      }).catch(() => {
        setIsSubmitting(false)
        setErrorMessage(lang('channels_message_select_one_channel'))
      })
    }
    else {
      channelsApi.updateWebWidget(dataToEdit._id, { ...dataToEdit, ...config }).then((response) => {
        setIsSubmitting(false)
        props.createWebWidget(config, selectedChannels, dataToEdit.token)
        setChannel([])
        setBrands([])
        setDelegations([])
        setChannelList(channels)
      }).catch(() => {
        setIsSubmitting(false)
        setErrorMessage(lang('channels_message_select_one_channel'))
      })
    }
  }

  return (
    <div className='web-widget-create'>
      <h1>{lang('channels_web_widget')}</h1>
      <legend>{lang('channels_web_widget_modal_subtitle')}</legend>
      <div className='web-widget'>
        <div className='selectors'>
          <SelectWithLabel
            label={lang('dashboard_channel')}
            name='channel'
            key='channel'
            options={channelOptions}
            multi={false}
            value={channel}
            selectedValues={channel}
            onChange={(value) => onChange([value], 'channel')}
            placeholder={lang('dashboard_selector_filter-by-channel')}
            classNameWrapper='channel-selector'
            isClearable
          />
          <BrandsAndDelegations
            onChangeBrands={(value) => onChange([value], 'brand')}
            currentBrands={brands || []}
            onChangeDelegations={(value) => onChange([value], 'delegation')}
            currentDelegations={delegations || []}
            multi={false}
            labelInside
            displayAllValues={false}
            isClearable
          />
          <ButtonTag
            value={lang('dashboard_reset-filters')}
            className='qr-reset-filters'
            onClick={() => {
              setChannel([])
              setBrands([])
              setDelegations([])
            }}
          />
        </div>
        <div className='channel-list-container'>
          <ModalChannelList
            key={dataToEdit ? `channelList-${dataToEdit._id}` : 'channelList-0'}
            availableChannels={channelList}
            selectedChannels={selectedChannels}
            maxChannels={8}
            modalKey='aocs'
            onSelected={data => {
              handleSelectedChannels(data)
            }}
          />
          {errorMessage && <span className='error-message'>{errorMessage}</span>}
        </div>
        <div className='wrapper-name-container'>
          <div className='name-container'>
            <label className='text-editor-title'>{lang('channels_widget_name')}</label>
            <input
              className='input-name'
              type={'text'}
              id={'name'}
              value={name}
              onChange={({ target }) => handleName(target.value)}
            />
            {errorMessageName && <span className='error-message'>{errorMessageName}</span>}
          </div>
          <div className='color-selector-container'>
            <div className='text-editor-title'>{lang('channels_web_widget_main_color')}</div>
            <ColorPickerInput color={channelColor} setColor={setChannelColor} />
          </div>
        </div>
        <div className='text-editor-title'>{lang('channels_web_widget_automatic_message')}</div>
        <div className='text-editor-container'>
          <div className='text-editor'>
            <TextEditor2
              id={`answer-${props.index}`}
              cols={5}
              rows={7}
              limit={AUTOMATIC_MESSAGE_LIMIT}
              placeholder={lang('dashboard_greeting-message-example')}
              options={["emojis"]}
              value={automaticMessageValue}
              onChange={e => handleAutomaticMessage(e.value)}
              minHeight={180}
              maxHeight={180}
              isTemplateValue
            />
            {errorMessageContent && <span className='error-message'>{errorMessageContent}</span>}
          </div>
          <div className='message-config-container'>
            <p className='message-info'>{lang('channels_web_widget_deferred')}</p>
            <InputControls
              className='message-config-container__switch'
              injectType='external'
              color='primary'
              label={lang('dashboard_active-in-desktop')}
              value={automaticMessageToggles.autoMsgInDesktop}
              onChange={value => setAutomaticMessageToggles(prevState => ({ ...prevState, autoMsgInDesktop: value }))}
            />
            <InputControls
              className='message-config-container__switch'
              injectType='external'
              color='primary'
              label={lang('dashboard_active-in-mobile')}
              value={automaticMessageToggles.autoMsgInMobile}
              onChange={value => setAutomaticMessageToggles(prevState => ({ ...prevState, autoMsgInMobile: value }))}
            />
          </div>
        </div>
        <div className='container-aocs-marks'>
          <div>
            <SelectWithLabel
              label={lang('channels_selector_orientation_page')}
              name='orientation'
              key='orientation'
              options={orientationOptions}
              multi={false}
              value={orientation}
              selectedValues={orientationOptions[0]}
              onChange={handleOrientation}
              classNameWrapper='orientation-selector'
              placeholder={lang('dashboard_select')}
            />
            {errorMessageOrientation && <span className='error-message'>{errorMessageOrientation}</span>}
            <div className='wrapper-position-aocs'>
              <div id={'mark1'} className={`aocs-mark aocs-selected${selectedAocs === 1 ? '' : 'not'}`} onClick={() => setSelectedAocs(1)} style={{ backgroundColor: selectedAocs === 1 ? channelColor : 'unset' }}></div>
              <div id={'mark2'} className={`aocs-mark aocs-selected${selectedAocs === 2 ? '' : 'not'}`} onClick={() => setSelectedAocs(2)} style={{ backgroundColor: selectedAocs === 2 ? channelColor : 'unset' }}></div>
              <div id={'mark3'} className={`aocs-mark aocs-selected${selectedAocs === 3 ? '' : 'not'}`} onClick={() => setSelectedAocs(3)} style={{ backgroundColor: selectedAocs === 3 ? channelColor : 'unset' }}></div>
              <div id={'mark4'} className={`aocs-mark aocs-selected${selectedAocs === 4 ? '' : 'not'}`} onClick={() => setSelectedAocs(4)} style={{ backgroundColor: selectedAocs === 4 ? channelColor : 'unset' }}></div>
              <div id={'mark5'} className={`aocs-mark aocs-selected${selectedAocs === 5 ? '' : 'not'}`} onClick={() => setSelectedAocs(5)} style={{ backgroundColor: selectedAocs === 5 ? channelColor : 'unset' }}></div>
              <div id={'mark6'} className={`aocs-mark aocs-selected${selectedAocs === 6 ? '' : 'not'}`} onClick={() => setSelectedAocs(6)} style={{ backgroundColor: selectedAocs === 6 ? channelColor : 'unset' }}></div>
              <div id={'mark7'} className={`aocs-mark aocs-selected${selectedAocs === 7 ? '' : 'not'}`} onClick={() => setSelectedAocs(7)} style={{ backgroundColor: selectedAocs === 7 ? channelColor : 'unset' }}></div>
              <div id={'mark8'} className={`aocs-mark aocs-selected${selectedAocs === 8 ? '' : 'not'}`} onClick={() => setSelectedAocs(8)} style={{ backgroundColor: selectedAocs === 8 ? channelColor : 'unset' }}></div>
              <div id={'mark9'} className={`aocs-mark aocs-selected${selectedAocs === 9 ? '' : 'not'}`} onClick={() => setSelectedAocs(9)} style={{ backgroundColor: selectedAocs === 9 ? channelColor : 'unset' }}></div>
            </div>
          </div>
          <div>
            <SelectWithLabel
              label={lang('channels_selector_orientation_mobile')}
              name='orientationM'
              key='orientationM'
              options={orientationOptionsM}
              multi={false}
              value={orientationM}
              selectedValues={orientationOptionsM[0]}
              onChange={handleOrientationM}
              classNameWrapper='orientation-selector'
              placeholder={lang('dashboard_select')}
            />
            {errorMessageOrientationM && <span className='error-message'>{errorMessageOrientationM}</span>}
            <div className='wrapper-position-aocs-mobile'>
              <div id={'mark1'} className={`aocs-mark aocs-selected${selectedAocsM === 1 ? '' : 'not'}`} onClick={() => setSelectedAocsM(1)} style={{ backgroundColor: selectedAocsM === 1 ? channelColor : 'unset' }}></div>
              <div id={'mark2'} className={`aocs-mark aocs-selected${selectedAocsM === 2 ? '' : 'not'}`} onClick={() => setSelectedAocsM(2)} style={{ backgroundColor: selectedAocsM === 2 ? channelColor : 'unset' }}></div>
              <div id={'mark3'} className={`aocs-mark aocs-selected${selectedAocsM === 3 ? '' : 'not'}`} onClick={() => setSelectedAocsM(3)} style={{ backgroundColor: selectedAocsM === 3 ? channelColor : 'unset' }}></div>
              <div id={'mark4'} className={`aocs-mark aocs-selected${selectedAocsM === 4 ? '' : 'not'}`} onClick={() => setSelectedAocsM(4)} style={{ backgroundColor: selectedAocsM === 4 ? channelColor : 'unset' }}></div>
              <div id={'mark5'} className={`aocs-mark aocs-selected${selectedAocsM === 5 ? '' : 'not'}`} onClick={() => setSelectedAocsM(5)} style={{ backgroundColor: selectedAocsM === 5 ? channelColor : 'unset' }}></div>
              <div id={'mark9'} className={`aocs-mark aocs-selected${selectedAocsM === 9 ? '' : 'not'}`} onClick={() => setSelectedAocsM(9)} style={{ backgroundColor: selectedAocsM === 9 ? channelColor : 'unset' }}></div>
            </div>
          </div>
        </div>
        <div className='buttons-widgets'>
          <Button
            secondary
            value={dataToEdit ? lang('channels_web_widget_edit_button') : lang('channels_web_widget_create_button')}
            onClick={createWidget}
            isSubmitting={isSubmitting}
          />
          {dataToEdit ? (
            <Button
              value={lang('dashboard_cancel')}
              onClick={() => setDataToEdit(null)}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default WebWidgetCreator
